export default __webpack_public_path__ + "static/sea-trip-ad26a961e73f811e75b7d2bda31dca9b.jpg";